export class ToastMessageEvent extends Event {
    constructor(message) {
        super('face-toast');
        this.detail = message;
    }
}
//# sourceMappingURL=ToastMessgeEvent.js.map